import {FOND_PERSON} from 'src/features/erp-sutor/sutor-fonds';

export const MENTION_CLASS = 'mention';
export const MENTION_USER_CLASS = 'mention-user';
export const MENTION_ID_ATTRIBUTE = 'data-mention-id';

export const MENTION_USER_PREFIX = '@';
export const MENTION_OTHER_PREFIX = '#';
export const MENTION_USER_FOND_ID = FOND_PERSON.fond;

export const MARKDOWN_SYMBOL_CLASS = 'markdown-symbol';
export const MARKDOWN_BOLD_CLASS = 'markdown-bold';
export const MARKDOWN_ITALIC_CLASS = 'markdown-italic';
export const MARKDOWN_BOLD_ITALIC_CLASS = 'markdown-bold-italic';
export const MARKDOWN_STRIKETHROUGH_CLASS = 'markdown-strikethrough';
export const MARKDOWN_CODE_CLASS = 'markdown-code';